<script>
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';

import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';
import AgentSelector from '../AgentSelector.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import { useVuelidate } from '@vuelidate/core';

// Passo 2 da criacao do time: 2 seletores separados — SUPERVISORES (minimo 1,
// obrigatorio) e AGENTES (minimo 1, obrigatorio). Ambos viram team_members;
// o papel vem do proprio usuario (account_users.role), sem coluna nova.
export default {
  components: {
    PageHeader,
    AgentSelector,
    NextButton,
  },
  validations: {
    selectedSupervisors: {
      isEmpty() {
        return !!this.selectedSupervisors.length;
      },
    },
    selectedAgents: {
      isEmpty() {
        return !!this.selectedAgents.length;
      },
    },
  },

  setup() {
    return { v$: useVuelidate() };
  },

  data() {
    return {
      selectedSupervisors: [],
      selectedAgents: [],
      selectedOperacionais: [],
      isCreating: false,
    };
  },

  computed: {
    ...mapGetters({
      agentList: 'agents/getAgents',
    }),

    supervisorList() {
      return this.agentList.filter(agent => agent.role === 'supervisor');
    },
    agentOnlyList() {
      return this.agentList.filter(agent => agent.role === 'agent');
    },
    // Operacionais do time (opcional, sem minimo) — pedido do Kairo 02/07/2026.
    operacionalList() {
      return this.agentList.filter(agent => agent.role === 'operacional');
    },
    teamId() {
      return this.$route.params.teamId;
    },
    headerTitle() {
      return this.$t('TEAMS_SETTINGS.ADD.TITLE', {
        teamName: this.currentTeam.name,
      });
    },
    currentTeam() {
      return this.$store.getters['teams/getTeam'](this.teamId);
    },
    disableSubmit() {
      return (
        !this.selectedSupervisors.length ||
        !this.selectedAgents.length ||
        this.isCreating
      );
    },
  },

  mounted() {
    this.$store.dispatch('agents/get');
  },

  methods: {
    updateSelectedSupervisors(newList) {
      this.v$.selectedSupervisors.$touch();
      this.selectedSupervisors = [...newList];
    },
    updateSelectedAgents(newAgentList) {
      this.v$.selectedAgents.$touch();
      this.selectedAgents = [...newAgentList];
    },
    updateSelectedOperacionais(newList) {
      this.selectedOperacionais = [...newList];
    },
    async addAgents() {
      this.isCreating = true;
      const { teamId } = this;
      const members = [
        ...new Set([
          ...this.selectedSupervisors,
          ...this.selectedAgents,
          ...this.selectedOperacionais,
        ]),
      ];

      try {
        await this.$store.dispatch('teamMembers/create', {
          teamId,
          agentsList: members,
        });
        router.replace({
          name: 'settings_teams_finish',
          params: {
            page: 'new',
            teamId,
          },
        });
        this.$store.dispatch('teams/get');
      } catch (error) {
        useAlert(error.message);
      }
      this.isCreating = false;
    },
  },
};
</script>

<template>
  <div class="h-full w-full p-8 col-span-6 overflow-auto">
    <form class="flex flex-col gap-4 mx-0" @submit.prevent="addAgents">
      <PageHeader
        :header-title="headerTitle"
        :header-content="$t('TEAMS_SETTINGS.ADD.DESC')"
      />

      <div class="w-full">
        <h4 class="text-heading-3 text-n-slate-12 mb-2">
          {{ $t('TEAMS_SETTINGS.ADD.SUPERVISORS_LABEL') }}
        </h4>
        <div v-if="v$.selectedSupervisors.$error">
          <p class="error-message pb-2">
            {{ $t('TEAMS_SETTINGS.ADD.SUPERVISOR_VALIDATION_ERROR') }}
          </p>
        </div>
        <AgentSelector
          :agent-list="supervisorList"
          :selected-agents="selectedSupervisors"
          :update-selected-agents="updateSelectedSupervisors"
          :is-working="isCreating"
          :show-submit-button="false"
        />
      </div>

      <div class="w-full">
        <h4 class="text-heading-3 text-n-slate-12 mb-2">
          {{ $t('TEAMS_SETTINGS.ADD.AGENTS_LABEL') }}
        </h4>
        <div v-if="v$.selectedAgents.$error">
          <p class="error-message pb-2">
            {{ $t('TEAMS_SETTINGS.ADD.AGENT_VALIDATION_ERROR') }}
          </p>
        </div>
        <AgentSelector
          :agent-list="agentOnlyList"
          :selected-agents="selectedAgents"
          :update-selected-agents="updateSelectedAgents"
          :is-working="isCreating"
          :show-submit-button="false"
        />
      </div>

      <div class="w-full">
        <h4 class="text-heading-3 text-n-slate-12 mb-2">
          {{ $t('TEAMS_SETTINGS.ADD.OPERACIONAIS_LABEL') }}
        </h4>
        <AgentSelector
          :agent-list="operacionalList"
          :selected-agents="selectedOperacionais"
          :update-selected-agents="updateSelectedOperacionais"
          :is-working="isCreating"
          :show-submit-button="false"
        />
      </div>

      <div class="flex justify-end w-full">
        <NextButton
          type="submit"
          :label="$t('TEAMS_SETTINGS.ADD.BUTTON_TEXT')"
          :disabled="disableSubmit"
          :is-loading="isCreating"
        />
      </div>
    </form>
  </div>
</template>
